(function () {
    'use strict';

    var serviceId = 'yandexReverseGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$ocLazyLoad', '$rootScope', yandexReverseGeocode]);

    function yandexReverseGeocode($q, $http, $ocLazyLoad, $rootScope) {
        var obj = {
            geocodeLatlng: geocodeLatlng
        };

        function ocLoadCheck(lat, lng, deferred) {
            var counter = false;
            angular.element('script').filter(function (i, el) {
                var s = el.getAttribute('src');
                if (s && s.indexOf('maps.googleapis.com/maps') > -1) {
                    counter = true;
                }
            });
            if (!counter)
                $ocLazyLoad.load([
                    'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                ]).then(function () {
                    googleBackUp(lat, lng, deferred);

                });
            else {
                googleBackUp(lat, lng, deferred);
            }
        }

        function googleBackUp(lat, lng, deferred) {
            var geocoder = new google.maps.Geocoder;
            var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        var last = results[0].formatted_address.split(', ').pop();
                        var result = results[0].formatted_address.replace(last, '').replace('/', ', ').replace('Provincia De', '').replace('Unnamed Road', '').replace('district', '').replace('province', '');
                        var toBeremoved = [];
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            if (results[0].address_components[i].types.indexOf('political') > -1)
                                toBeremoved.push(results[0].address_components[i].long_name);
                        }
                        for (var i = 0; i < toBeremoved.length; i++) {
                            result = result.replace(toBeremoved[i], '');
                        }
                        result = result.replaceAll(' ,', '');

                        deferred.resolve(result);
                    } else {
                        deferred.reject();
                    }
                } else {
                    deferred.reject();
                }
            });
        }


        function geocodeLatlng(lat, lng) {
            var deferred = $q.defer();

            const langu = $rootScope.lang === 'tr' ? 'tr_TR' : $rootScope.lang === 'es-ES' ? 'es_ES' : $rootScope.lang === 'pt-PT' ? 'pt_PT' : 'en_US';
            // const countryId = ($rootScope.country === 'turkiye') ? 1 : ($rootScope.country === 'espana') ? 2 : ($rootScope.country === 'portugal') ? 3 : 0;
            // const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

            if ($rootScope.country !== 'turkiye')
                ocLoadCheck(lat, lng, deferred);
            else
                $http({
                    method: 'GET',
                    dataType: 'json',
                    data: '',
                    url: 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&geocode=' + lng + ',' + lat + '&lang=' + langu + '&format=json'
                }).then(function (geocodeOk) {
                    if (geocodeOk.status === 200) {
                        try {
                            var addr1, addr = geocodeOk.data.response.GeoObjectCollection.featureMember[0].GeoObject;
                            if (geocodeOk.data.response.GeoObjectCollection.featureMember[1])
                                addr1 = geocodeOk.data.response.GeoObjectCollection.featureMember[1].GeoObject;

                            if (addr1 && (addr.description.indexOf(addr1.description) > -1 || addr1.description.indexOf(addr.description) > -1)) {
                                var result = addr.name + ", " + addr.description;
                                var pop = result.split(', ').pop();
                                result = result.replace(pop, '').replace('Provincia de ', '').replace('District', '').replace('Province', '');

                                if (result.slice(-2) === ', ')
                                    result = result.slice(0, -2);

                                deferred.resolve(result);
                            }
                            else {
                                ocLoadCheck(lat, lng, deferred);
                            }
                        }
                        catch (err) {
                            ocLoadCheck(lat, lng, deferred);
                        }
                    }
                    else {
                        ocLoadCheck(lat, lng, deferred);

                    }
                }, function () {
                    ocLoadCheck(lat, lng, deferred);
                });
            return deferred.promise;
        }

        return obj;
    }

})();
